import {
	Box,
	Button,
	CircularProgress,
	ClickAwayListener,
	Container,
	IconButton,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { confirmImportStockFormByStoreActions, currentUserActions } from '../redux/store'
import axios from 'axios'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import { DOMAIN } from '../utils/api'
import { handleError } from '../utils/error'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../utils/storage'
import { borderFormat, mainGreen, mainGrey } from '../utils/color'

export default function ConfirmImportStockByStoreForm(props) {
	const { request } = useSelector((state) => state.confirmImportStockByStoreForm)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const [fileUpload, setFileUpload] = useState([])
	const [disabled, setDisabled] = useState(false)
	const [preview, setPreview] = useState([])
	const [loadingConfirm, setLoadingConfirm] = useState(false)
	const [confirmImport, setConfirmImport] = useState({
		values: {
			quantity: request.quantity,
		},
		errors: { quantity: '' },
	})

	const onFileUploadChange = async (e) => {
		setFileUpload(e.target.files)
	}

	useEffect(() => {
		if (!fileUpload) {
			setPreview(undefined)
			return
		}
		let preview = []
		for (let i = 0; i < fileUpload.length; i++) {
			preview.push(URL.createObjectURL(fileUpload[i]))
		}
		setPreview(preview)
	}, [fileUpload])

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...confirmImport.values, [name]: value }
		let newError = { ...confirmImport.errors }

		if (name === 'quantity') {
			if (Number(value) <= 0 && value.trim() !== '') {
				newError[name] = '* Khối lượng phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}

		setConfirmImport({ values: newValue, errors: newError })
	}

	const handleSubmit = async (event, id) => {
		event.preventDefault()
		const quantity = confirmImport.values.quantity
		if (String(quantity).trim() === '') {
			alert('Dữ liệu không được để trống')
			return
		}
		if (confirmImport.errors.quantity.trim() !== '') {
			return
		}
		setDisabled(true)
		setLoadingConfirm(true)
		try {
			const formData = new FormData()
			formData.append('quantity', quantity)
			formData.append('id', id)
			for (let i = 0; i < fileUpload.length; i++) {
				formData.append('image', fileUpload[i])
			}
			const response = await axios({
				url: `${DOMAIN}/complete-request/${currentUser.store}`,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				},
				data: formData,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			props.getSubStock()
			props.getRequests()
			dispatch(confirmImportStockFormByStoreActions.hideConfirmImportStockByStoreForm())
			setLoadingConfirm(false)
			setDisabled(false)
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<Box
			position='fixed'
			sx={{
				bottom: 0,
				left: mediaMd ? 300 : 0,
				right: 0,
				zIndex: 99,
			}}>
			<ClickAwayListener
				onClickAway={() => {
					dispatch(confirmImportStockFormByStoreActions.hideConfirmImportStockByStoreForm())
				}}>
				<Container
					onClick={(e) => {
						e.stopPropagation()
					}}
					onTouchEnd={(e) => {
						e.stopPropagation()
					}}
					sx={{
						background: mainGrey,
						borderTop: borderFormat,
						borderLeft: borderFormat,
						borderRight: borderFormat,
						maxWidth: '600px',
					}}
					maxWidth={false}>
					<Typography
						sx={{
							mt: 2,
							color: '#fff',
							background: mainGreen,
							textAlign: 'center',
							padding: '3px 0',
							borderRadius: '3px',
						}}>
						Yêu cầu {request.quantity}kg tạo bởi {request.request.user.name} vào {request.request.timeStamp}
					</Typography>
					{loadingConfirm && (
						<Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
							<CircularProgress sx={{ color: mainGreen }} />
						</Box>
					)}
					{!loadingConfirm && (
						<>
							<Box noValidate display='flex' justifyContent='flex-start' alignItems='flex-end' sx={{ pt: 2 }}>
								{confirmImport.errors.quantity === '' ? (
									<Box sx={{ width: '48%' }}>
										<TextField
											fullWidth
											type='number'
											value={confirmImport.values.quantity}
											sx={{
												mt: 1,
												background: '#fff',
											}}
											id='quantity'
											label='Cân thực tế (kg)'
											name='quantity'
											autoComplete='quantity'
											onChange={handleChange}
										/>
									</Box>
								) : (
									<Box sx={{ width: '48%' }}>
										<TextField
											fullWidth
											type='number'
											value={confirmImport.values.quantity}
											sx={{
												mt: 1,
												background: '#fff',
											}}
											error
											id='quantity'
											label='Cân thực tế (kg)'
											name='quantity'
											autoComplete='quantity'
											onChange={handleChange}
										/>
									</Box>
								)}
								<Box sx={{ ml: 1, mr: 1, display: 'flex', alignItems: 'flex-end' }}>
									{preview?.map((img, index) => {
										return (
											<img
												loading='lazy'
												key={index}
												style={{
													width: 50,
													marginRight: '8px',
												}}
												src={img}
												alt='preview'
											/>
										)
									})}
									<>
										<IconButton sx={{ padding: '0' }}>
											<label htmlFor='choose-photo-import' style={{ display: 'flex', cursor: 'pointer' }}>
												<AddPhotoAlternateRoundedIcon
													sx={{
														color: mainGreen,
													}}
												/>
											</label>
										</IconButton>
										<input
											multiple
											accept='image/*'
											onChange={onFileUploadChange}
											id='choose-photo-import'
											type='file'
											style={{ display: 'none' }}
										/>
									</>
								</Box>
							</Box>
							{confirmImport.errors.quantity && (
								<Typography sx={{ color: '#ff0000' }}>{confirmImport.errors.quantity}</Typography>
							)}
							<Box>
								<Button
									fullWidth
									disabled={disabled}
									type='button'
									variant='contained'
									sx={{
										mt: 2,
										mb: 2,
										background: mainGreen,
										'&:hover': { background: mainGreen },
									}}
									onClick={(e) => {
										handleSubmit(e, request._id)
									}}>
									Xác nhận nhập hàng
								</Button>
							</Box>
						</>
					)}
				</Container>
			</ClickAwayListener>
		</Box>
	)
}
